module.exports = __webpack_public_path__ + "static/media/location_icon.5e2043b6.svg";